import React, { useEffect } from 'react';
import type { CustomNodePosition, ICustomNodeData } from '../../shared';
import { useFramework } from '../hooks';
import { BaseScaleView } from './base-scale-view';

export const CustomLayer: React.FC<{ position: CustomNodePosition; zIndex?: number }> = React.memo(
    ({ position, zIndex }) => {
        const framework = useFramework();
        const [nodes, setNodes] = React.useState<ICustomNodeData[]>([]);

        useEffect(() => {
            return framework.service.customData.onNodeChange((data) => {
                const customNodes = data.filter((item) => item.position === position);
                setNodes(customNodes);
            });
        }, [position]);

        return (
            <>
                {nodes.map((item) => {
                    if (item.autoPosition) {
                        return (
                            <BaseScaleView
                                style={{ zIndex }}
                                layer={framework.service.frame.getShape(item.frameId)}
                                key={item.type}
                            >
                                {item.node}
                            </BaseScaleView>
                        );
                    }
                    return (
                        <div style={{ zIndex, width: '100%', height: '100%' }} key={item.type}>
                            {item.node}
                        </div>
                    );
                })}
            </>
        );
    },
);
